import { Component, OnInit } from '@angular/core';
import { NgxCarousel } from 'ngx-carousel';

@Component({
  selector: 'app-cases',
  templateUrl: './cases.component.html',
  styleUrls: ['./cases.component.css']
})
export class CasesComponent implements OnInit {

  carouselTile: NgxCarousel;

  constructor() { }

  ngOnInit() {


    this.carouselTile = {
      grid: {xs: 1, sm: 2, md: 2, lg: 3, all: 0},
      slide: 1,
      speed: 400,
      animation: 'lazy',
      point: {
        visible: true,
        pointStyles: `
          .ngxcarouselPoint {
            list-style-type: none;
            text-align: center;
            padding: 10px;
            margin: 0;
            white-space: nowrap;
            overflow: auto;
            box-sizing: border-box;
          }
          .ngxcarouselPoint li {
            display: inline-block;
            background: #deedea;
            border-radius: 35%;
            padding: 4px 6px;
            margin: 0 5px;
            transition-timing-function: cubic-bezier(.17, .67, .83, .67);
            transition: .4s;
          }
          .ngxcarouselPoint li:hover {
          cursor: pointer;
          }
          .ngxcarouselPoint li.active {
              background: #85baac;
              padding: 4px 14px;
          }
        `
      },
      load: 1,
      touch: true,
      easing: 'ease'
    }
  }

  public carouselTileLoad(evt: any) {

    // const len = this.carouselTileItems.length
    // if (len <= 30) {
    //   for (let i = len; i < len + 10; i++) {
    //     this.carouselTileItems.push(i);
    //   }
    // }

  }

  // carouselLoad will trigger this funnction when your load value reaches
  // it is helps to load the data by parts to increase the performance of the app
  // must use feature to all carousel


}



// WEBPACK FOOTER //
// C:/Users/anach/Desktop/tengtu-website/src/app/components/home/cases/cases.component.ts